var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 44,
    viewBox: "0 0 30 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 4.3688C10.3586 4.3688 6.58762 8.02055 6.58762 12.5076V18.8295H23.4121V12.5076C23.4121 8.02055 19.6334 4.3688 14.9998 4.3688ZM27.9235 18.8295V12.5076C27.9235 10.8222 27.58 9.18113 26.9082 7.63615C26.2594 6.15032 25.3281 4.81233 24.1372 3.65915C22.954 2.51335 21.5724 1.6115 20.0304 0.983163C18.435 0.332649 16.7479 0 14.9998 0C13.2517 0 11.5647 0.332649 9.9693 0.983163C8.42732 1.6115 7.04564 2.51335 5.86243 3.65915C4.67922 4.80494 3.74793 6.14293 3.09144 7.63615C2.41968 9.18113 2.07617 10.8148 2.07617 12.5076V18.8295H0V38.5519C0 41.5606 2.51908 44 5.62596 44H24.374C27.4809 44 30 41.5606 30 38.5519V18.8295H27.9235ZM17.3359 37.0439L16.8244 31.692C17.7252 31.1154 18.3282 30.1248 18.3282 29.0012C18.3282 27.2271 16.8397 25.7856 15 25.7856C13.1603 25.7856 11.6718 27.2197 11.6718 29.0012C11.6718 30.1248 12.2672 31.1154 13.1756 31.692L12.6641 37.0439H17.3359Z",
    fill: "#4A567A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBig);
export default __webpack_public_path__ + "static/media/lock-big.a73c5c22942512f07726ab71cca5d581.svg";
export { ForwardRef as ReactComponent };